import { HTTP } from '../../../http-common';
import { httpError } from '../../../models/httpError';

import { Internet } from '../../../models/Internet';

import { getField, updateField } from 'vuex-map-fields';

const state = {
  addresses: [],
  rows: [new Internet()],
  contacts: [],
  message: new httpError(),
};

//getters

const getters = {
  // customer: state => state.customer,

  getField,
};

//Mutations
const mutations = {
  addUpgradeRow(state, payload) {
    state.rows.push(
      new Internet({
        internetType: payload.internetType ? payload.internetType : null,
        serviceNumber: payload.serviceNumber ? payload.serviceNumber : null,
        addressID: payload.addressID,
        contractTerm: payload.contractTerm,
        ratePlanID: payload.ratePlanID,
        contactID: payload.contactID,
        upgrade: payload.upgrade,
      })
    );
  },
  addRow(state, payload) {
    var months = 0;
    var rateplan = 0;
    // if (state.rows.length > 0) {
    //   rateplan = state.rows[0].ratePlanID;
    // }

    months = payload.months;

    state.rows.push(
      new Internet({
        addressID: payload.addressID,
        contractTerm: months,
        ratePlanID: rateplan,
        contactID: payload.contactID,
      })
    );
  },
  deleteIndex(state, index) {
    state.rows.splice(index, 1);
  },
  delRow(state) {
    state.rows.pop();
  },
  deleteRow(state, index) {
    state.rows.splice(index, 1);
  },
  setInternet(state, internet) {
    if (Array.isArray(internet))
      internet.forEach((data) => {
        data.contractTerm = parseInt(data.contractTerm);
      });
    state.rows.length = 0;
    state.rows = internet;
  },
  setAddresses(state, addresses) {
    state.addresses = addresses;
  },
  addAddresses(state, address) {
    state.addresses.push(address);
  },

  setProgress(state, message) {
    state.message = message;
  },
  setContacts(state, contacts) {
    //delete state.contacts;
    state.contacts = contacts;
  },
  addContact(state, contact) {
    state.contacts.push(contact);
  },
  updateField,
};

//ACTIONS
const actions = {
  resetInternet({ commit }) {
    commit('setInternet', [new Internet()]);
    commit('setAddresses', []);
    commit('setContacts', []);
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  getInternet({ commit, rootState, dispatch }) {
    return new Promise((resolve, reject) => {
      var orderID = rootState.orders.rows[0].orderID;
      var response = HTTP.get('order/GetInternet/' + orderID);
      dispatch(
        'setMessage',
        new httpError({
          message: 'Retrieving Internet orders',
          httpStatus: 200,
        })
      );
      response
        .then(async function (data) {
          if (data.status === 200) {
            var resultData = data.data;
            if (typeof resultData !== 'undefined' && resultData.length > 0) {
              commit('setInternet', resultData);
              dispatch(
                'setMessage',
                new httpError({ message: 'Retrieved OK', httpStatus: 200 })
              );
              resolve(resultData);
            }
          } else {
            commit('setInternet', []);
            resolve();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addNewInternet({ commit, state, rootState, dispatch }, service = '') {
    return new Promise((resolve, reject) => {
      var orderID = rootState.orders.rows[0].orderID;

      var internets = state.rows.filter(
        (x) => x.internetType != null && x.ratePlanID != 0
      );

      var response = HTTP.post('order/AddInternetOrder/' + orderID, internets);
      response
        .then(function (data) {
          if (data.data) {
            commit('setInternet', data.data.data);
            // dispatch(
            //   'setMessage',
            //   new httpError({ message: 'Saved successfully', httpStatus: 200 })
            // );
            resolve(data.data.data);
          }
        })
        .catch(function (err) {
          dispatch(
            'setMessage',
            new httpError({
              message: err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getContacts({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      var orderID = rootState.orders.rows[0].orderID;

      var response = HTTP.get('order/getContacts/' + orderID);
      response
        .then(function (data) {
          if (data.status === 200) {
            commit('setContacts', data.data);
            resolve(data.data);
          } else {
            commit('setContacts', []);
            resolve(data.data);
          }
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  },
  addContacts({ commit, state, rootState }, contact) {
    return new Promise((resolve, reject) => {
      var orderID = rootState.orders.rows[0].orderID;
      var response = HTTP.post('order/addContact/' + orderID, state.contacts);
      response
        .then(function (data) {
          commit('setContacts', data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeIndex({ commit }, index) {
    commit('deleteIndex', index);
  },
  async removeRows({ state, commit, dispatch, rootState }, newVal) {
    //rowCount is the number of rows to finish with
    var oldVal = 0 || state.rows.length;
    let isNew = false;

    if (state.rows[newVal].internetID === 0) isNew = true;

    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1]);
      commit('delRow');
    }

    if (!isNew) {
      try {
        var cont = await HTTP.delete(
          'order/DeleteInternetFromOrder/' + rootState.orders.rows[0].orderID,
          { data: rows }
        );
        dispatch(
          'setMessage',
          new httpError({ message: 'Rows deleted', httpStatus: 200 })
        );
        return Promise.resolve(cont);
      } catch (e) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'error deleting rows: ' + e,
            httpStatus: 500,
          })
        );
        return Promise.reject(e);
      }
    }
  },
  removeRow({ state, rootState, commit, dispatch }, index) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        'order/DeleteInternetFromOrder/' + rootState.orders.rows[0].orderID,
        { data: [state.rows[index]] }
      )
        .then(() => {
          commit('deleteRow', index);
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'error deleting rows: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  getInternetUpgrade({}, custNo) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(`order/GetInternetUpgrade/${custNo}`);
      response
        .then(function (data) {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeDataBackup({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      HTTP.delete('order/RemoveDataBackup/' + payload)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'error deleting rows: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
